export default {
	getByMobile(mobile, cb) {
		//cashier用来查询余额和券
		this.http.post(`/member/getSummary/${mobile}`, {}).then((response) => {
			cb(response)
		})
	},
	status(id, to, cb, ecb) {
		this.http
			.post(`/member/status/${id}/${to}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getVouchers(memberid, cb, ecb) {
		this.http
			.post('/member/queryVoucher/', {
				memberid
			})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getById(id, cb, ecb) {
		this.http
			.get(`/member/getById/${id}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getByUserId(uid, cb, ecb) {
		this.http
			.get(`/member/getByUserId/${uid}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	enroll(form, cb, ecb, options = {}) {
		this.http
			.post(`/member/enroll`, form, options)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getSummary(id, cb) {
		this.http.get('/member/getSummary/' + id, {}).then((response) => {
			cb(response)
		})
	},
	getBalance(cb) {
		this.http.get('/member/getBalance/', {}).then((response) => {
			cb(response)
		})
	},
	getAccount(cb) {
		this.http
			.get('/member/getAccount/', {})
			.then((response) => cb && cb(response))
	},
	getAccountLog(id, params, cb) {
		this.http
			.get('/member/getAccountLog/' + id, params)
			.then((response) => cb && cb(response))
	},
	getCredit(cb) {
		this.http
			.get('/member/getCredit/', {})
			.then((response) => cb && cb(response))
	},
	getCreditLog(id, params, cb) {
		this.http
			.get('/member/getCreditLog/' + id, params)
			.then((response) => cb && cb(response))
	},
	getLevelLog(id, params, cb) {
		this.http
			.get('/member/getLevelLog/' + id, params)
			.then((response) => cb && cb(response))
	},
	getPaycode(cb) {
		this.http
			.get('/member/getPaycode/', {})
			.then((response) => cb && cb(response))
	},
	getPaycodeStatus(code, cb) {
		this.http
			.get('/member/getPaycodeStatus/' + code, { loading: false })
			.then((response) => cb && cb(response))
	},
	getTopupProfile(cb) {
		this.http.get('/member/getTopupProfile/', {}).then((response) => {
			cb(response)
		})
	},
	createTopupOrder(form, cb) {
		this.http.post('/member/createTopupOrder/', form).then((response) => {
			cb(response)
		})
	},
	getLevel(cb, ecb) {
		this.http
			.get('/member/getLevel/', {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getAllLevels(cb) {
		this.http.get('/member/getAllLevels/', {}).then((response) => {
			cb(response)
		})
	},
	searchLevel(params, cb) {
		this.http.get('/member/searchLevel/', { params }).then((response) => {
			cb(response)
		})
	},
	getAllPrivs(cb) {
		this.http.get('/member/getAllPrivs/', {}).then((response) => {
			cb(response)
		})
	},
	search(params, cb) {
		this.http.get('/member/search/', { params }).then((response) => {
			cb(response)
		})
	},
	add(form, cb, ecb) {
		this.http
			.post('/member/add/', form)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	update(form, cb, ecb) {
		this.http
			.post('/member/update/', form)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	changeLevel(form, cb, ecb) {
		this.http
			.post(`/member/changeLevel`, form)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	buyLevel(form, cb, ecb) {
		this.http
			.post(`/member/buyLevel`, form)
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	getPendingOrder(cb) {
		this.http.get('/member/getPendingOrder/', {}).then((response) => {
			cb(response)
		})
	},
	mergeAssets(fuid, tuid, cb, ecb) {
		this.http
			.get(`/member/mergeAssets/${fuid}/${tuid}`, {})
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	},
	verifyCardToken(memberid, token, cb, ecb) {
		this.http
			.post(`/member/verifyCardToken`, { memberid, token })
			.then((response) => cb && cb(response))
			.catch((err) => ecb && ecb(err))
	}
}
